import React from 'react'
import { useIntl } from 'react-intl'
import classNames from 'classnames'

export default ({ stats }) => {
  const { formatMessage } = useIntl()

  return (
    <dl className="w-full grid grid-cols-1 gap-px bg-gray-200 border-b bordery-gray-200 sm:grid-cols-2 lg:grid-cols-4">
      {stats.map((stat) => (
        <div
          key={stat.title}
          className="flex flex-wrap items-baseline justify-between gap-x-4 gap-y-2 bg-white px-4 py-6 sm:px-6 xl:px-8"
        >
          <dt className="text-sm font-medium leading-6 text-gray-500">{stat.title}</dt>
          <dd
            className={classNames(
              stat.changeType === '+' ? 'text-positive' : 'text-negative',
              'text-xs font-medium'
            )}
          >
            {stat.stat}
          </dd>
          <dd className="w-full flex-none text-2xl font-medium leading-10 tracking-tight text-gray-900">
            {stat.primary}
          </dd>
        </div>
      ))}
    </dl>
  )
}
